module.exports = __webpack_public_path__ + "img/yxmh_06.5dbde00c.jpg";